export function mapGetPitch() { return this._cameraPitch ?? 0; }
